import { enqueueModalAtom } from '@/atoms/modalQueueAtoms';
import { SESSION_MERGE_EDUCATION_MODAL_ID } from '@/atoms/session-merge-onboarding-modal-ids';
import { ModalPriority } from '@/types/modal-queue.types';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { showEnabledToastOnEducationCloseAtom } from '../atoms';

/**
 * Post-enable follow-up shared by every path that turns auto session merge on
 * ("Turn on" on the awareness cards, the settings toggle). Every enable opens
 * the instructional modal — deliberately not seen-gated, so re-enabling from
 * the settings toggle re-teaches the matching behaviour — and arms
 * `showEnabledToastOnEducationCloseAtom` so the "Session merge enabled" toast
 * fires once the modal is dismissed.
 */
export function useShowSessionMergeInstructions(): {
  showSessionMergeInstructions: () => void;
} {
  const enqueueModal = useSetAtom(enqueueModalAtom);
  const setShowToastOnEducationClose = useSetAtom(showEnabledToastOnEducationCloseAtom);

  const showSessionMergeInstructions = useCallback(() => {
    setShowToastOnEducationClose(true);
    enqueueModal({
      id: SESSION_MERGE_EDUCATION_MODAL_ID,
      priority: ModalPriority.NORMAL,
      dismissible: true,
    });
  }, [enqueueModal, setShowToastOnEducationClose]);

  return { showSessionMergeInstructions };
}
